document.addEventListener("DOMContentLoaded", function() {
    // Select the h1 element inside .article-banner-heading
    const heading = document.querySelector('.article-banner-heading h1');

    // Check if the heading exists
    if (heading) {
        // Get the current text and capitalize it
        const originalText = heading.textContent;
        const capitalizedText = originalText
            .toLowerCase() // Convert the text to lowercase
            .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
        
        // Update the heading with the capitalized text
        heading.textContent = capitalizedText;
    }
});


document.querySelectorAll('.breadcrumbs__list li a').forEach(a => {
    a.textContent = a.textContent.toLowerCase();
});

document.querySelectorAll('.blog-post .blog-post-content h3').forEach(h3 => {
    h3.textContent = h3.textContent.toLowerCase();
});


// Swiper for Collection Slider
const swiper = new Swiper('.collection-slider', {
  loop: false,
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next-collection',
    prevEl: '.swiper-button-prev-collection',
  },
  speed: 600, // Adjust transition speed (600ms for smooth transition)
  effect: 'slide', // Default effect is 'slide', but you can use other effects like 'fade' or 'cube' if desired
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  }
});

// Swiper for Recent Articles Slider
const swiper2 = new Swiper('.recent-articles-slider', {
  loop: true,
  slidesPerView: 1,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next-articles',
    prevEl: '.swiper-button-prev-articles',
  },
  speed: 600, // Adjust transition speed (600ms for smooth transition)
  effect: 'slide', // Default effect is 'slide', but you can try 'fade' or 'cube' for different transitions
});
